import { useEffect, ReactNode } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { getUserInfoApi } from '@/api/user'

/**
 * 用户信息提供者：在登录状态下周期性刷新用户资料
 */
export function UserProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated, updateUser, logout } = useAuthStore()

  useEffect(() => {
    if (!isAuthenticated) return
    getUserInfoApi()
      .then((user) => {
        updateUser(user)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          logout()
          window.location.href = '/'
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  return <>{children}</>
}
